import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { NgxSessionActivitySelectorComponent } from './session-activity-selector.component';

export const ngxSessionActivitySelectorModule = angular.module('ngxSessionActivitySelectorModule', [])
	.directive('ngxSessionActivitySelector', downgradeComponent({ component: NgxSessionActivitySelectorComponent }))
	.name;
